module.exports = __webpack_public_path__ + "static/marriage-intro-image-55633b43f7669b3a0f3885e728e4a91f.jpg";